import React from 'react'
import InfoWithIcon from "./InfoWithIcon"

const AboutUsInfo = () => (
  <div className='about-us-info-container' style={{marginTop: '100px'}}>
    <div className='container'>
      <InfoWithIcon 
        className={'info-icon-container'}
        icon={'about-us-info-icon first'}
        header={'Personal service to help you build wealth'}
        body1={'We boast a highly skilled team of loan consultants that are available to make the process easy for you.'}
        body2={'Our team are locally based in Australia and make themselves available to help you at a time that suits your schedule.'}
        body3={'We are committed to getting to understand what you really need and want today, and then how we can help you build wealth into the future.'}
      />
      <InfoWithIcon 
        className={'info-icon-container reverse'}
        reverse={true}
        icon={'about-us-info-icon third'}
        header={'Wide eligibility. Properties Australia-wide'}
        body1={'At Yard, we recognise that Australians can have unique circumstances.'}
        body2={'Whether you’re a salaried employee, self-employed, located overseas, are looking for a loan through a trust or company, or buying in a regional area.'}
        body3={'Yard tries to meet a wide range of circumstances and your loan consultant can look to see if Yard can help you.'}
      />
      <InfoWithIcon 
        className={'info-icon-container'}
        icon={'about-us-info-icon second'}
        header={'Digital application process'}
        body1={'At many lenders, the application process is inefficient, feels ancient and seems to take an eternity. It’s busy work, but it’s not meaningful.'}
        body2={'We’ve changed this. We use the latest technology so you’re no longer tracking down paperwork or sweating whilst you wait to understand where you stand.'}
        body3={'Yard makes the home loan experience better for people. So you can focus on what matters.'}
      />
    </div>
  </div>
);

export default AboutUsInfo
